import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { getProductOrders } from '../../services/cards';
import { TGetProductOrdersResponse } from '../../types/cards/card-types';

const useGetProductOrders = (
  params?: { status?: string; include_dispatch_log?: boolean; dispatch_address_id?: string; sort_by?: string },
  options?: Partial<UseInfiniteQueryOptions<any, any, any, any>>
) => {
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    isPending,
    status: queryStatus,
    isError,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['get-card-batches', params],
    queryFn: async ({ pageParam }) => {
      const response = await getProductOrders({
        next_cursor: pageParam,
        ...params,
      });
      console.log('Raw product orders API response:', response);
      return response;
    },
    initialPageParam: '',
    getNextPageParam: (lastPage) => (lastPage as any)?.next_cursor,
    select: (data) => (data as any)?.pages.flatMap((page: any) => page?.product_orders || []),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    ...(options || {}),
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isPending,
    isFetchingNextPage,
    isError,
    status: queryStatus,
    refetch,
  };
};

export default useGetProductOrders; 